import { Fragment, React, useEffect, useState } from "react";
import "./dashboard.css";
// import admincardsapplications from "../../../src/assets/images/admin-cards-applications.svg";
import admincardsapplications from "../../assets/images/application_form_superadmin.png";
import admincardsactions from "../../../src/assets/images/admin-cards-actions.png";
import admincardspatients from "../../../src/assets/images/admin-cards-patients.png";
import adminassigned from "../../../src/assets/images/activity_icon_superadmin1.svg";
import adminactions from "../../../src/assets/images/admin-actions.svg";
import adminpatient from "../../../src/assets/images/admin-patient.svg";
import adminassignment from "../../../src/assets/images/admin-assignment.svg";
import user_application from "../../../src/assets/images/Application_user.svg";
import user_action from "../../../src/assets/images/Pending_action_user.svg";
import { useDispatch, useSelector } from "react-redux";
import { platformLayout } from "../../utils/constants";
import { getAllCountList } from "../../api/orgnizations";
import { failed } from "../../utils/Tostify";
import { useNavigate } from "react-router";
import Loader from "../../components/Loader/Loader";
import { getPendingTasks } from "../../api/Applications";
import { Link } from "react-router-dom";
import { resetCurrentPage, setListFilter } from "../../context/reducers/pagination";
import { resetCurrentPage as resetApplnPage , setListFilter as setApplnListFilter } from "../../context/reducers/adminApplnState";

function Dashboard() {
  let role = localStorage.getItem("userRole");
  localStorage.setItem("prevRoute", window.location.pathname);
  let user = useSelector((state) => state?.userReducer?.user);
  let token = useSelector(state => state.userReducer.token);
  const [isLoading, setIsLoading] = useState(false);
  const [countData, setCountData] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const clinicId = localStorage.getItem("currentHospitalId");
  const [data, setData] = useState([]);

  const getCountList = async () => {
    let res = "";
    try {
      setIsLoading(true);
      const payload = {orgId: localStorage.getItem("currentOrgId"), clinicId : localStorage.getItem("currentHospitalId"),userId : user._id};
      res = await getAllCountList({ values: payload, dispatch, token });
      if (res?.status === "SUCCESS") {
        setCountData(res?.data);
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const AllTasks = async () => {
    let res;
    try {
        setIsLoading(true);
        res = await getPendingTasks({dispatch, token, clinicId});
        if (res?.status === "SUCCESS") {
        setData(res?.data);
        setIsLoading(false);
        }else{
        setIsLoading(false);
        }
    } catch (error) {
        failed(res?.message);
        setIsLoading(false);
    }
  };

  useEffect(()=>{
    getCountList();
    AllTasks();
  },[]);

  const countAllTasks = () => {
    if (!Array.isArray(data)) return 0;

    return data.reduce((total, app) => {
      return total + (app.tasks?.length || 0);
    }, 0);
  };

  const countPendingAllTasks = () => {
    if (!Array.isArray(data)) return 0;

    return data.reduce((total, app) => {
      const filteredTasks = (app.tasks || []).filter(task =>
        (task.status === 'To Do' || task.status === 'InProgress' || task.status === "Pending") &&
        task.assignTo?._id === user._id
      );
      return total + filteredTasks.length;
    }, 0);
  };

  const handleNavigateWithFilter = (listFilter = "all") => {
    dispatch(setListFilter(listFilter)); // Set Redux filter dynamically
    dispatch(resetCurrentPage()); // Optional: reset pagination to page 1
    navigate("/clinic/patient-list"); // Navigation without state
  };

  const handleApplnNavigateWithFilter = (listFilter = "all") => {
    dispatch(setApplnListFilter(listFilter));
    dispatch(resetApplnPage());
    navigate("/app/admin-application");
  };

  return (
    <Fragment>
      {isLoading ? <Loader /> : null}
    <div className="home-container">
      {role == platformLayout.Organization ? (
        <Fragment>
          <h2 className="home-title">Welcome {user?.firstName + " " + user?.lastName} !</h2>
          <p className="home-desc">Navigate through the quick links below to review new patients, assignments and follow up on pending actions.</p>
          <div className="row">

            <div className="col-lg-3 col-md-6 mb-3">
              <div className="box" onClick={() => handleNavigateWithFilter("new")}>
                <div className="text-center">
                  <img src={adminpatient} alt="New Patient" className="img-fluid img_block" />
                </div>
                <div className="inner_box">
                  <h4>New Patients</h4>
                  <p>New patients need to be reviewed</p>
                  <div className="box-count">
                    {countData?.newPatientCount || 0}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mb-3">
            <div className="box" onClick={() => handleNavigateWithFilter("assigned-me")}>
            <div className="text-center">
              <img src={adminassignment} alt="New Assignment" className="img-fluid img_block" />
              </div>
              <div className="inner_box">
                <h4>New Assignments</h4>
                <p>New Patients assigned to me</p>
                <div className="box-count">
                {countData?.patientAssignedMeCount ? countData?.patientAssignedMeCount : 0}
                </div>
              </div>
            </div>
            </div>

            <div className="col-lg-3 col-md-6 mb-3">
            <div className="box" onClick={() => navigate('/app/activity',
                { state: { activeTab : "assigned" }})}
            >
            <div className="text-center">
              <img src={adminactions} alt="Pending Actions" className="img-fluid img_block" />
              </div>
              <div className="inner_box">
                <h4>Pending Actions</h4>
                <p>Tasks need your attention for resolution</p>
                <div className="box-count">
                {countPendingAllTasks()}
                </div>
              </div>
            </div>
            </div>

            <div className="col-lg-3 col-md-6 mb-3">
            <div className="box" onClick={() => handleApplnNavigateWithFilter("assigned-me")}>
            <div className="text-center">
              <img src={adminassigned} alt="Assigned Applications" className="img-fluid img_block" />
              </div>
              <div className="inner_box">
                <h4>Assigned Applications</h4>
                <p>Pending applications assigned to me</p>
                <div className="box-count">
                {countData?.assignedToMeApplicationCount ? countData?.assignedToMeApplicationCount : 0}
                </div>
              </div>
            </div>
            </div>

          </div>
          <div className="cards row">

           <div className="col-lg-4 mb-3" onClick={() => handleNavigateWithFilter("all")} style={{ cursor: "pointer" }}>
              <div className="total_patient row m-0 card-item">
                <div className="card-img col-6">
                  <img src={admincardspatients} alt="" />
                </div>
                <div className="card-data col-6">
                  <h3>{countData?.allPatientCount || 0}</h3>
                  <p>Total Patients</p>
                </div>
              </div>
          </div>

            <div className="col-lg-4 mb-3">
            <div className="box" onClick={() => navigate('/app/activity',
                { state: { activeTab : "all" }})}
            >
            <div className="row m-0 total_actions card-item">
              <div className="card-img col-6">
                <img src={admincardsactions} alt="" />
              </div>
              <div className="card-data col-6">
                <h3>{countAllTasks()}</h3>
                <p>Total Actions</p>
              </div>
            </div>
            </div>
            </div>

            <div className="col-lg-4 mb-3" onClick={() => handleApplnNavigateWithFilter("all")} style={{ cursor: "pointer" }}>
            <div className="row m-0 total_applications card-item">
              <div className="card-img col-6">
                <img src={admincardsapplications} alt="" />
              </div>
              <div className="card-data col-6">
                <h3>{countData?.allApplicationsCount ? countData?.allApplicationsCount : 0}</h3>
                <p>Total Applications</p>
              </div>
            </div>
            </div>

          </div>
        </Fragment>) : (<Fragment>
          <h2 className="home-title">Welcome {user?.firstName}</h2>
          <p className="home-desc">Navigate through the quick links below to review applicaion in process and follow up on pending tasks.</p>
          <div className="row">
            <div className="col-lg-6 border_patient_blk mb-2">
            <div className="slide box_one d-flex flex-column h-100">
              <div className="text-center">
              <img src={user_application} alt="New Patient" className="img-fluid img_block" />
              </div>
              <div className="inner_box" onClick={() => navigate('/patient/application')}>
                <h4>Applications</h4>
                <p>View applications in process</p>
                <div className="box-count">
                  {countData?.inProcessPatientApplicationCount}
                </div>
              </div>
            </div>
            </div>
            <div className="col-lg-6 mb-2">
            <div className="slide d-flex flex-column h-100">
            <div className="text-center">
              <img src={user_action} alt="New Assignment" className="img-fluid img_block" />
              </div>
              <div className="inner_box" onClick={() => navigate('/app/patient-activity')}>
                <h4>Pending actions</h4>
                <p>Application need your attension for response</p>
                <div className="box-count">
                 {countData?.inProcessPatientPendingApplicationCount}
                </div>
              </div>
            </div>
            </div>
          </div>
        </Fragment>)}
    </div>
    </Fragment>
  );
}
export default Dashboard;
